import { ModalContent } from './Modal.styled'
import { ModalRoot } from './Root/ModalRoot.pure'

export const Modal = {
  Root: ModalRoot,
  Content: ModalContent,
}
